import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';

import {
  catchError,
  map,
  mergeMap,
  Observable,
  reduce,
} from 'rxjs';
import { LocationGroupAPIUrls } from './location-group-api-urls';
import { LocationGroupWebEntity } from './entities/location-groups-web-entity';
import { LocationGroupRepository } from 'planning-portal-library/src/lib/core/repositories/location-group.repository';
import { LocationGroup } from 'planning-portal-library/src/lib/core/domain/models/location-group';
import { BaseResponse } from '../../../shared/base.response';
import { LocationGroupWebRepositoryMapper } from './entities/location-group-web-repository-mapper';
import { CreateLocationGroup } from 'planning-portal-library/src/lib/core/domain/requests/location-group/create-location-group-request';
import { EditLocationGroup } from 'planning-portal-library/src/lib/core/domain/requests/location-group/edit-location-group-request';
import { CreateLocationGroupsForAMSRequest } from 'planning-portal-library/src/lib/core/domain/requests/location-group/create-location-groups-for-ams-request';
import { RenameLocationGroup } from 'planning-portal-library/src/lib/core/domain/requests/location-group/rename-location-group';

@Injectable({ providedIn: 'root' })
export class LocationGroupWebRepository extends LocationGroupRepository {  
  private readonly environment = injectEnvironment();
  private readonly locationGroupMapper = new LocationGroupWebRepositoryMapper();
  

  constructor(private readonly http: HttpClient) {
    super();
  }
  GetLocationGroupsByPlanContainerID(
    request: string
  ): Observable<LocationGroup[]> {
    return this.http
      .get<BaseResponse<LocationGroupWebEntity[]>>(
        `${this.environment.url}${LocationGroupAPIUrls.GetLocationGroupsByPlanContainerID}`,
        {
          params: {
            planContainerID: request,
          },
        }
      )
      .pipe(
        mergeMap((response) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.locationGroupMapper.mapFrom))
      .pipe(
        reduce(
          (items: LocationGroup[], item: LocationGroup) => [...items, item],
          []
        )
      );
  }

  GetLocationsGroupById(request: string): Observable<LocationGroup> {
    return this.http
      .get<BaseResponse<LocationGroupWebEntity>>(
        `${this.environment.url}${LocationGroupAPIUrls.GetLocationsGroupsById}`,
        {
          params: {
            id: request,
          },
        }
      )
      .pipe(
        map(
          (response: BaseResponse<LocationGroupWebEntity>) => response.result!
        ),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.locationGroupMapper.mapFrom));
  }
  DeleteLocationGroup(request: string): Observable<boolean> {
    return this.http
      .delete<BaseResponse<unknown>>(
        `${this.environment.url}${LocationGroupAPIUrls.DeleteLocationGroup}`,
        {
          params: {
            locationId: request,
          },
        }
      )
      .pipe(
        map((data) => {
          return data.successful;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }

  CreateLocationGroup(
    request: CreateLocationGroup
  ): Observable<BaseResponse<string>> {
    return this.http
      .post<BaseResponse<string>>(
        `${this.environment.url}${LocationGroupAPIUrls.CreateLocationGroup}`,
        request
      )
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }
  EditLocationGroup(
    request: EditLocationGroup
  ): Observable<BaseResponse<boolean>> {
    return this.http
      .post<BaseResponse<boolean>>(
        `${this.environment.url}${LocationGroupAPIUrls.EditLocationGroup}`,
        request
      )
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }

    CreateLocationsGroupsByAMS(
    request: CreateLocationGroupsForAMSRequest
  ): Observable<BaseResponse<string>> {
    return this.http
      .post<BaseResponse<string>>(
        `${this.environment.url}${LocationGroupAPIUrls.CreateLocationGroupsForAMS}`,
        request
      )
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }
 
  UpdateLocationGroupNameById(
    request: RenameLocationGroup
  ): Observable<BaseResponse<string>> {
    return this.http
      .post<BaseResponse<string>>(
        `${this.environment.url}${LocationGroupAPIUrls.UpdateLocationGroupTitle}`,
        request
      )
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }
}
